import { Component, OnInit, Input } from '@angular/core';
import { ModalController, NavParams} from '@ionic/angular';
import { NgForm } from '@angular/forms';
import { ISupplementProtocolDetail } from 'src/app/models';
import moment from 'src/app/utils/moment';
import { OrganizationService } from 'src/app/services';

@Component({
  selector: 'app-supplement-protocol-settings',
  templateUrl: './supplement-protocol-settings.page.html',
  styleUrls: ['./supplement-protocol-settings.page.scss'],
})
export class SupplementProtocolSettingsPage implements OnInit {

  public action: "add" | "edit";
  public dates: {start: Date, end: Date};
  public endPickerStartAt: Date = (moment as any)().startOf("day").toDate();
  public form: any;
  public isFormSubmitted: boolean;
  public supplementProtocol: ISupplementProtocolDetail;
  public maxDate = (moment as any)().add(1, "year").endOf("year").toISOString();
  private defaultEndHour = 0;
  private endDateTouched = false;

  @Input() type: "user" | "library";
  @Input() mode: "protocol" | "category";
  @Input() premium = false;

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private organizationService: OrganizationService
  ) {
    this.action = this.navParams.get("action");
    this.supplementProtocol = this.navParams.get("supplementProtocol");
    this.dates = {
      start: new Date(this.supplementProtocol.startDate),
      end: this.supplementProtocol.endDate? new Date(this.supplementProtocol.endDate) : null
    };

    const programSettings = this.organizationService.getAppOrganization()?.getSetting("programs");
    const orgDefaultStartTime: string | null = programSettings?.defaultStartTime || null;
    const orgDefaultEndTime: string | null = programSettings?.defaultEndTime || null;
    this.defaultEndHour = this.parseHour(orgDefaultEndTime);
    this.endDateTouched = !!this.dates.end;

    if (this.action === "add" && orgDefaultStartTime) {
      const [hourStr] = orgDefaultStartTime.split(":");
      const hour = parseInt(hourStr, 10);
      if (!Number.isNaN(hour)) {
        const startMoment = (moment as any)(this.dates.start).hour(hour).minute(0).second(0).millisecond(0);
        this.dates.start = startMoment.toDate();
      }
    }

    if (this.action === "add" && this.dates.end && orgDefaultEndTime) {
      const [hourStr] = orgDefaultEndTime.split(":");
      const hour = parseInt(hourStr, 10);
      if (!Number.isNaN(hour)) {
        this.dates.end = (moment as any)(this.dates.end).hour(hour).minute(0).second(0).millisecond(0).toDate();
      }
    }

    const endStart = this.dates.end ? (moment as any)(this.dates.end) : (moment as any)().startOf("day");
    if (!this.dates.end && orgDefaultEndTime) {
      const [hourStr] = orgDefaultEndTime.split(":");
      const hour = parseInt(hourStr, 10);
      if (!Number.isNaN(hour)) {
        endStart.hour(hour).minute(0).second(0).millisecond(0);
      }
    }
    this.endPickerStartAt = this.dates.end || endStart.toDate();
   }

  ngOnInit() {
  }

  endDateChanged(value: Date) {
    this.dates.end = this.normalizeNewEndDate(value);
  }

  onSubmit(formData: NgForm) {
    this.isFormSubmitted = true;
    if(!formData.valid) {
      return
    }

    this.supplementProtocol.startDate = this.dates.start.toISOString();
    this.supplementProtocol.endDate = this.dates.end? this.dates.end.toISOString() : null;

    this.modalCtrl.dismiss({ 
      status: "submitted",
      data: this.supplementProtocol
    });
  }

  getCounter(data: string, maxLength: number) {
    return `${data? maxLength - data.length : maxLength} /  ${maxLength}`
  }

  cancel() {
    this.modalCtrl.dismiss({ status: "canceled" });
  }

  private parseHour(timeStr: string | null): number {
    if (!timeStr) {
      return 0;
    }
    const hour = parseInt(timeStr.split(":")[0], 10);
    return Number.isNaN(hour) ? 0 : hour;
  }

  private normalizeNewEndDate(value: Date): Date {
    if (!value) {
      this.endDateTouched = false;
      return null;
    }
    const next = (moment as any)(value);
    if (!this.endDateTouched && next.hour() === (moment as any)().hour()) {
      next.hour(this.defaultEndHour).minute(0).second(0).millisecond(0);
    }
    this.endDateTouched = true;
    return next.toDate();
  }
}
